import { webWeights } from './webWeights'

export const systemWeights = {
  thin: webWeights.thin,
  light: webWeights.light,
  regular: webWeights.regular,
  semibold: webWeights.semibold,
  bold: webWeights.bold,
}
